const doc = [[({"image":"facebook3@3x.png"}), ({"image":"facebook2@3x.png"}), ({"image":"facebook1@3x.png"}), ({"text":"+13"})]];
module.exports = doc.length <= 1 ? doc[0] : doc;